import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Menu } from "app/components/Icons";
import clsx from "clsx";
import React from "react";

import { dropdownTriggerClassname } from "app/components/Dropdown";
import { GroupAction, GroupByTypeEnum } from "../../../../types";

import GroupMenuItems from "./ListGroupMenuItems";
import AddGroupSubMenu from "./AddGroupSubMenu";
import HiddenGroupsSubMenu from "./HiddenGroupsSubMenu";
import useGroupActions from "./useListGroupActions";
import CustomTooltip from "app/components/Tooltip";
import { TicketGroup } from "../../../Tickets/types";

interface Props {
  group: TicketGroup;
  groupBy: GroupByTypeEnum;
  setIsGroupModalOpen: (val: GroupAction) => void;
  setIsRemoveGroup: (val: boolean) => void;
}
export const menuItemStyles =
  "flex gap-2 pl-4 pr-[8px] py-[12px] text-sm text-secondary cursor-pointer rounded hover:bg-gray-400 outline-none";
export default function RowGroupActions({
  group,
  groupBy,
  setIsGroupModalOpen,
  setIsRemoveGroup,
}: Props) {
  const actions = useGroupActions({
    group,
    setIsGroupModalOpen,
    setIsRemoveGroup,
  });

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          className={clsx(
            "flex items-center hover:bg-gray-200 rounded outline-none",
            dropdownTriggerClassname,
          )}
        >
          <CustomTooltip
            text="  Group actions"
            contentClassName="p-[10px]"
            position="bottom"
          >
            <Menu size="20" />{" "}
          </CustomTooltip>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="start"
          sideOffset={5}
          className="bg-white rounded shadow-md py-2 z-50"
        >
          <GroupMenuItems
            group={group}
            handleClick={(type: GroupAction) => {
              actions.handleClick(type, group);
            }}
          />

          {groupBy === GroupByTypeEnum.CUSTOM_TITLES && (
            <AddGroupSubMenu
              onAction={(type: GroupAction) => {
                actions.handleClick(type, group);
              }}
            />
          )}

          <HiddenGroupsSubMenu
            hiddenGroups={actions.hiddenGroups}
            groupBy={groupBy}
            onAction={(type, group) => {
              actions.handleClick(type, group);
            }}
          />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
